import classNames from 'classnames'
import React, { CSSProperties } from 'react'

import styles from './Divider.module.scss'

type Props = { rounded?: boolean }
type VerticalProps = Props & { height?: CSSProperties['height'] }

const HorizontalDivider: React.FC<Props> = ({ rounded }) => (
  <div className={classNames(styles.horizontalDivider, { [styles.rounded]: rounded })} />
)
const VerticalDivider: React.FC<VerticalProps> = ({ rounded, height }) => (
  <div
    style={{ height }}
    className={classNames(styles.verticalDivider, { [styles.rounded]: rounded })}
  />
)

export const Divider = { Horizontal: HorizontalDivider, Vertical: VerticalDivider }
